import * as React from 'react';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FormModalLayout } from '../../../components/FormLayout';
import { NewReviewContext } from '../../../utils/newReview/context';
import { Success } from '../../../components/DailyrentNewReview/Success';
import { trackShow } from './tracking';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getObjectId } from '../../../selectors/objectInfo';
import { getPublishedReviewId } from '../../../selectors/newReview/getPublishedReviewId';
import { getNewReviewData } from '../../../selectors/newReview/getNewReviewData';
import { ENewReviewStep } from '../../../types/newReview';
import { fetchCreateTripReviewPageDataAction } from '../../../actions/newReview/fetchCreateTripReviewPageData';
import { TThunkDispatch } from '../../../types/redux';

let alreadyTracked = false;

export const SuccessContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { custom } = useApplicationContext();
  const objectId = useSelector(getObjectId);
  const publishedReviewId = useSelector(getPublishedReviewId);
  const formState = useSelector(getNewReviewData);
  const { isOpened, onClose } = useContext(NewReviewContext);

  const handleClose = React.useCallback(async () => {
    onClose();
    dispatch(fetchCreateTripReviewPageDataAction());
  }, [onClose, dispatch]);

  React.useEffect(() => {
    if (isOpened && !alreadyTracked && publishedReviewId) {
      trackShow(objectId, publishedReviewId, formState, custom.deviceType);
      alreadyTracked = true;
    }
  }, [isOpened, objectId, publishedReviewId, formState, custom.deviceType]);

  return (
    <FormModalLayout
      title="Новый отзыв"
      shortTitle="Новый отзыв"
      onClose={handleClose}
      type="info"
      open={isOpened}
      testId="NewReview"
      step={ENewReviewStep.Success}
    >
      <Success close={onClose} />
    </FormModalLayout>
  );
};
